var Student = "طالب";
var jobRole = {
	"Job role": "الدور الوظيفي",
	"Academic / Researcher": "باحث / أكاديمي",
	"Advisor / Consultant": "استشاري / مستشار",
	"Business Executive": "مسؤول تنفيذي في الأعمال",
	"Developer / Engineer": "مهندس / مطور",
	"Entrepreneur (Founder/Co-Founder)": "رائد أعمال (مؤسس/شريك مؤسس)",
	"IT Executive": "مسؤول تنفيذي في تكنولوجيا المعلومات",
	"IT Professional or Technical Manager": "أخصائي تكنولوجيا المعلومات أو مدير فني",
	"Press / Media Analyst": "محلل إعلامي / صحفي",
	"Sales / Marketing": "المبيعات / التسويق",
	Student: Student,
	"Solution or Systems Architect": "مهندس نظم أو حلول",
	"System Administrator": "مسؤول نظام",
	"Venture Capitalist": "صاحب رأس مال في مشروع"
};

export { Student, jobRole as default };
